import { createContext, useState, useEffect, useReducer } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "sr"
  );

  // Koristimo useReducer da forsiramo rerender pri promeni jezika
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "sr");
      forceUpdate(); // Forsira rerender odmah
    };

    window.addEventListener("languageChange", updateLanguage);
    return () => window.removeEventListener("languageChange", updateLanguage);
  }, []);

  const changeLanguage = (lang) => {
    localStorage.setItem("language", lang);
    window.dispatchEvent(new Event("languageChange"));
    setLanguage(lang);
    forceUpdate(); // Osigurava rerender
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
